<template>
  <div class="dynamic-tags">
    <el-tag
      v-for="tag in dynamicTags"
      :key="tag"
      :closable="!disabled"
      :disable-transitions="false"
      type="info"
      @close="handleClose(tag)"
    >
      {{ tag }}
    </el-tag>
    <el-input
      v-if="inputVisible"
      ref="saveTagInput"
      v-model="inputValue"
      :class="['input-new-tag', dynamicTags.length > 0 ? '' : 'init']"
      size="small"
      :disabled="disabled"
      @keyup.enter.native="handleInputConfirm"
      @blur="handleInputConfirm"
    >
    </el-input>
    <el-button
      v-else
      :class="['button-new-tag', dynamicTags.length > 0 ? '' : 'init']"
      size="small"
      :disabled="disabled"
      @click="showInput"
      >{{ btnStr }}</el-button
    >
  </div>
</template>
<script>
export default {
  name: 'DynamicTags',
  props: {
    value: {
      type: Array,
      default: () => {
        return []
      }
    },
    disabled: Boolean,
    btnStr: {
      type: String,
      default: '+ 新建标签'
    }
  },
  data() {
    return {
      dynamicTags: [],
      inputVisible: false,
      inputValue: ''
    }
  },
  watch: {
    value: {
      handler(val, oldval) {
        this.dynamicTags = val
      },
      deep: true
    }
  },
  mounted() {
    this.dynamicTags = this.value
  },
  methods: {
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1)
    },

    showInput() {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },

    handleInputConfirm() {
      let inputValue = this.inputValue.trim()
      if (inputValue && this.dynamicTags.every(e => e != inputValue)) {
        if (/^[A-Za-z0-9_]+$/.test(inputValue)) {
          this.dynamicTags.push(inputValue)
          this.$emit('input', this.dynamicTags)
        } else {
          this.$message({
            type: 'info',
            message: '请输入英文、数字和下划线的组合!'
          })
        }
      }
      this.inputVisible = false
      this.inputValue = ''
    }
  }
}
</script>
<style scoped lang="scss">

@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
.dynamic-tags {
  @include adaptation(
    (
      --dynamic-tags-tag-height: 32px,
      --dynamic-tags-tag-line-height: 30px,
      --dynamic-tags-tag-margin-left: 6px,
      --dynamic-tags-btn-new-tag-margin-left: 6px,
      --dynamic-tags-btn-new-tag-height: 32px,
      --dynamic-tags-btn-new-tag-line-height: 30px,
      --dynamic-tags-input-new-tag-width: 90px,
      --dynamic-tags-input-new-tag-margin-left: 6px,
    )
  );
  .el-tag {
    height: var(--dynamic-tags-tag-height);
    line-height: var(--dynamic-tags-tag-line-height);
  }

  .el-tag + .el-tag {
    margin-left: var(--dynamic-tags-tag-margin-left);
  }

  .button-new-tag {
    margin-left: var(--dynamic-tags-btn-new-tag-margin-left);
    height: var(--dynamic-tags-btn-new-tag-height);
    line-height: var(--dynamic-tags-btn-new-tag-line-height);
    padding-top: 0;
    padding-bottom: 0;
  }

  .button-new-tag.init {
    margin-left: 0;
  }

  .input-new-tag {
    width: var(--dynamic-tags-input-new-tag-width);
    margin-left: var(--dynamic-tags-input-new-tag-margin-left);
    vertical-align: bottom;
  }

  .input-new-tag.init {
    margin-left: 0;
  }
}
</style>
